"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpers = require("@paprika/stylers/lib/helpers");

var _Check = _interopRequireDefault(require("@paprika/icon/lib/Check"));

var _ColoredCaution = _interopRequireDefault(require("@paprika/icon/lib/ColoredCaution"));

var _ExclamationCircle = _interopRequireDefault(require("@paprika/icon/lib/ExclamationCircle"));

var _InfoCircle = _interopRequireDefault(require("@paprika/icon/lib/InfoCircle"));

var _Lock = _interopRequireDefault(require("@paprika/icon/lib/Lock"));

var _Portal = _interopRequireDefault(require("@paprika/helpers/lib/components/Portal"));

var types = _interopRequireWildcard(require("./types"));

var sc = _interopRequireWildcard(require("./Toast.styles"));

var _icons;

var icons = (_icons = {}, (0, _defineProperty2["default"])(_icons, types.toastKinds.SUCCESS, _Check["default"]), (0, _defineProperty2["default"])(_icons, types.toastKinds.WARNING, _ColoredCaution["default"]), (0, _defineProperty2["default"])(_icons, types.toastKinds.ERROR, _ExclamationCircle["default"]), (0, _defineProperty2["default"])(_icons, types.toastKinds.INFO, _InfoCircle["default"]), (0, _defineProperty2["default"])(_icons, types.toastKinds.LOCKED, _Lock["default"]), _icons);
var minimumCloseTimeout = 1500;

var Toast = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var autoCloseDelay = props.autoCloseDelay,
      canAutoClose = props.canAutoClose,
      children = props.children,
      hasCloseButton = props.hasCloseButton,
      isFixed = props.isFixed,
      isOpen = props.isOpen,
      isPolite = props.isPolite,
      kind = props.kind,
      onClose = props.onClose,
      renderDelay = props.renderDelay,
      zIndex = props.zIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["autoCloseDelay", "canAutoClose", "children", "hasCloseButton", "isFixed", "isOpen", "isPolite", "kind", "onClose", "renderDelay", "zIndex"]);

  var toastRef = _react["default"].useRef(null);

  _react["default"].useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        if (toastRef.current) {
          if (!moreProps.tabIndex) toastRef.current.setAttribute("tabindex", "-1");
          toastRef.current.focus();
        }
      }
    };
  });

  var _React$useState = _react["default"].useState(isOpen === undefined ? true : isOpen),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      isToastOpen = _React$useState2[0],
      setIsToastOpen = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(false),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      shouldRender = _React$useState4[0],
      setShouldRender = _React$useState4[1];

  var autoCloseTimer = _react["default"].useRef(null);

  var renderTimer = _react["default"].useRef(null);

  var ariaRole = isPolite ? "status" : "alert";
  var defaultZIndex = isFixed ? (0, _helpers.zValue)(7) : null;
  var isVisuallyHidden = kind === Toast.types.kind.VISUALLY_HIDDEN;

  var memoizedStartAutoCloseTimer = _react["default"].useCallback(function () {
    function handleDelayedClose() {
      clearTimeout(autoCloseTimer.current);
      if (isOpen === undefined) setIsToastOpen(false);
      onClose();
    }

    autoCloseTimer.current = setTimeout(handleDelayedClose, Math.max(autoCloseDelay, minimumCloseTimeout));
  }, [autoCloseDelay, isOpen, onClose]);

  var memoizedStartRenderTimer = _react["default"].useCallback(function () {
    function handleDelayedRender() {
      clearTimeout(renderTimer.current);
      setShouldRender(true);
    }

    renderTimer.current = setTimeout(handleDelayedRender, renderDelay);
  }, [renderDelay]);

  function handleClose() {
    if (autoCloseTimer.current) clearTimeout(autoCloseTimer.current);
    if (renderTimer.current) clearTimeout(renderTimer.current);

    if (isOpen === undefined) {
      setIsToastOpen(false);
      setShouldRender(false);
    }

    onClose();
  }

  function renderContent() {
    if (!shouldRender) return null;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !isVisuallyHidden && /*#__PURE__*/_react["default"].createElement(sc.IconStyled, {
      as: icons[kind],
      kind: kind,
      "aria-hidden": true
    }), /*#__PURE__*/_react["default"].createElement(sc.Content, null, children), hasCloseButton && !isVisuallyHidden && /*#__PURE__*/_react["default"].createElement(sc.CloseButtonStyled, {
      isSemantic: false,
      onClick: handleClose,
      size: types.SMALL
    }));
  }

  function renderToast() {
    return /*#__PURE__*/_react["default"].createElement(sc.Toast, (0, _extends2["default"])({
      "data-pka-anchor": "toast",
      hasCloseButton: hasCloseButton,
      isFixed: isFixed,
      role: ariaRole,
      kind: kind,
      zIndex: zIndex || defaultZIndex,
      ref: toastRef
    }, moreProps, {
      shouldRender: shouldRender
    }), renderContent());
  }

  _react["default"].useEffect(function () {
    if (canAutoClose || isVisuallyHidden) {
      memoizedStartAutoCloseTimer();
      return function () {
        clearTimeout(autoCloseTimer.current);
      };
    }
  }, [canAutoClose, isVisuallyHidden, memoizedStartAutoCloseTimer]);

  _react["default"].useEffect(function () {
    if (isToastOpen) {
      memoizedStartRenderTimer();
      return function () {
        clearTimeout(renderTimer.current);
      };
    }
  }, [isToastOpen, memoizedStartRenderTimer]);

  _react["default"].useEffect(function () {
    if (!isOpen) {
      setShouldRender(false);
    }
  }, [isOpen]);

  _react["default"].useEffect(function () {
    if (isOpen === undefined) return;
    if (isOpen !== isToastOpen && !canAutoClose && !isVisuallyHidden) setIsToastOpen(isOpen);
  }, [isOpen, isToastOpen, canAutoClose, isVisuallyHidden]);

  if (!isToastOpen) return null;

  if (isFixed) {
    return /*#__PURE__*/_react["default"].createElement(_Portal["default"], null, renderToast());
  }

  return renderToast();
});

Toast.types = {
  kind: types.toastKinds,
  size: types.SMALL
};
var propTypes = {
  /** Duration (in ms) before Toast will automatically close (if canAutoClose is true). */
  autoCloseDelay: _propTypes["default"].number,

  /** Will automatically close after 1500ms (or longer if provided by autoCloseDelay). */
  canAutoClose: _propTypes["default"].bool,

  /** Content of the Toast. */
  children: _propTypes["default"].node,

  /** If the component should have a 'close' button. */
  hasCloseButton: _propTypes["default"].bool,

  /** How "controlled" Toast is shown / hidden. */
  isOpen: _propTypes["default"].bool,

  /** If the Toast is fixed to the top of the viewport. This will render the Toast as a Portal. */
  isFixed: _propTypes["default"].bool,

  /** A11y: If the Toast is polite (will wait until screen reader is finished before speaking) or assertive (will interrupt immediately). */
  isPolite: _propTypes["default"].bool,

  /** Determines the styling of the Toast. */
  kind: _propTypes["default"].oneOf([Toast.types.kind.SUCCESS, Toast.types.kind.WARNING, Toast.types.kind.ERROR, Toast.types.kind.INFO, Toast.types.kind.LOCKED, Toast.types.kind.VISUALLY_HIDDEN]),

  /** Callback that is executed after clicking the 'close' button. */
  onClose: _propTypes["default"].func,

  /** Delay in ms before content of Toast is rendered (to improve UX with screen readers). */
  renderDelay: _propTypes["default"].number,

  /** The z-index of the Toast. */
  zIndex: _propTypes["default"].number
};
var defaultProps = {
  canAutoClose: false,
  autoCloseDelay: 5000,
  children: null,
  hasCloseButton: true,
  isOpen: undefined,
  isFixed: false,
  isPolite: false,
  kind: Toast.types.kind.INFO,
  onClose: function onClose() {},
  renderDelay: 20,
  zIndex: null
};
Toast.displayName = "Toast";
Toast.propTypes = propTypes;
Toast.defaultProps = defaultProps;
var _default = Toast;
exports["default"] = _default;
//# sourceMappingURL=Toast.js.map